// @flow
import patientSchema from "src/schemas/patientSchema";
import { relationshipReducer } from "src/utils/reducerUtils";

export const patientRelationships = relationshipReducer({
  name: "patients",
  relationshipSchemas: patientSchema.relationshipSchemas
});
